export const Browser = "Browser";
export const Extension = "Extension";
export var Mode;
(function (Mode) {
    Mode[Mode["Read"] = 0] = "Read";
    Mode[Mode["Write"] = 1] = "Write";
})(Mode || (Mode = {}));
export var StorageProviderName;
(function (StorageProviderName) {
    StorageProviderName[StorageProviderName["Web3Storage"] = 0] = "Web3Storage";
    StorageProviderName[StorageProviderName["Lighthouse"] = 1] = "Lighthouse";
})(StorageProviderName || (StorageProviderName = {}));
export var SignMethod;
(function (SignMethod) {
    SignMethod["signMessage"] = "signMessage";
    SignMethod["_signTypedData"] = "_signTypedData";
})(SignMethod || (SignMethod = {}));
